import { makeVar } from "@apollo/client";

// repricingVar stores both the repricing boolean and the update time.
// Without the update time I was having issues with some components not
// correctly seeing that the repricingVar had updated when updates happened
// multiple times quickly.
export const repricingVar = makeVar([false, new Date().getTime()]);
